'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('pdfjs-dist/web/pdf_viewer.css');
var pdfjs = require('pdfjs-dist');
var pdf_viewer_mjs = require('pdfjs-dist/web/pdf_viewer.mjs');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);
var pdfjs__namespace = /*#__PURE__*/_interopNamespaceDefault(pdfjs);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var PageSize = /** @class */ (function () {
    function PageSize() {
    }
    PageSize.createNullObject = function () {
        var data = new PageSize();
        data.height = 0;
        data.width = 0;
        return data;
    };
    PageSize.create = function (height, width) {
        var data = new PageSize();
        data.height = height;
        data.width = width;
        return data;
    };
    return PageSize;
}());
var PageProperties = /** @class */ (function () {
    function PageProperties() {
    }
    PageProperties.create = function (page, scale) {
        var data = new PageProperties();
        data.page = page;
        data.scale = scale;
        return data;
    };
    return PageProperties;
}());

var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader(props) {
        return _super.call(this, props) || this;
    }
    Loader.prototype.render = function () {
        var parentElement = document.getElementById("page-viewer");
        var top = 0;
        var height = '0%';
        var left = 0;
        var width = '100%';
        if (parentElement && this.props.show) {
            height = parentElement.getBoundingClientRect().height;
            width = parentElement.getBoundingClientRect().width;
        }
        return (React__namespace.createElement("div", { style: { top: top, left: left, width: width, height: height }, className: this.props.show ? "awesome-pdf-viewer-loader visible" : "awesome-pdf-viewer-loader" },
            React__namespace.createElement("div", { "data-loader": "circle-side", className: "icon" })));
    };
    return Loader;
}(React__namespace.Component));

globalThis.pdfjsLib = pdfjs__namespace;
var ViewerMode;
(function (ViewerMode) {
    ViewerMode[ViewerMode["Normal"] = 0] = "Normal";
    ViewerMode[ViewerMode["Read"] = 1] = "Read";
})(ViewerMode || (ViewerMode = {}));
var PageMode;
(function (PageMode) {
    PageMode[PageMode["SinglePage"] = 1] = "SinglePage";
    PageMode[PageMode["MultiPage"] = 2] = "MultiPage";
    PageMode[PageMode["Classic"] = 3] = "Classic";
})(PageMode || (PageMode = {}));
var PageMatchesCount = /** @class */ (function () {
    function PageMatchesCount() {
    }
    PageMatchesCount.createNullObject = function () {
        var data = new PageMatchesCount();
        data.page = 0;
        data.matchCount = 0;
        return data;
    };
    PageMatchesCount.create = function (page, matchCount) {
        var data = new PageMatchesCount();
        data.page = page;
        data.matchCount = matchCount;
        return data;
    };
    return PageMatchesCount;
}());
var SearchResult = /** @class */ (function () {
    function SearchResult() {
    }
    SearchResult.createNullObject = function () {
        var data = new SearchResult();
        data.matchCount = 0;
        data.pagesMatch = [];
        return data;
    };
    SearchResult.create = function (matchesCount, pagesMatches) {
        var data = new SearchResult();
        data.matchCount = matchesCount;
        data.pagesMatch = pagesMatches;
        return data;
    };
    return SearchResult;
}());
var PdfSource = /** @class */ (function () {
    function PdfSource() {
    }
    PdfSource.createNullObject = function () {
        return new PdfSource();
    };
    PdfSource.createFromUrl = function (url) {
        var data = new PdfSource();
        data.url = url;
        return data;
    };
    PdfSource.createFromBase64 = function (base64String) {
        var data = new PdfSource();
        data.base64String = base64String;
        return data;
    };
    return PdfSource;
}());
/** @class */ ((function (_super) {
    __extends(PdfJSSource, _super);
    function PdfJSSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PdfJSSource.createPDFDocumentProxy = function (pdfDocumentProxy) {
        var data = new PdfJSSource();
        data.pdfDocumentProxy = pdfDocumentProxy;
        return data;
    };
    return PdfJSSource;
})(PdfSource));
var ViewerBase = /** @class */ (function () {
    function ViewerBase() {
        var _this = this;
        this._currentMatchIndex = -1;
        this.getEventBus = function () {
            _this._eventBus = new pdf_viewer_mjs.EventBus();
            return _this._eventBus;
        };
        this.getCurrentPage = function () {
            return _this._pdfViewer.currentPageNumber;
        };
        this.gotoPage = function (page) {
            _this._pdfViewer.currentPageNumber = page;
        };
        this.getPageSize = function (page) {
            var currentPage = _this._pdfViewer._pages[page - 1];
            if (currentPage != null) {
                return PageSize.create(currentPage.viewport.height / currentPage.viewport.scale, currentPage.viewport.width / currentPage.viewport.scale);
            }
            else {
                return PageSize.createNullObject();
            }
        };
        this.setScale = function (scale) {
            _this._pdfViewer.currentScale = scale;
        };
        this.getCurrentScale = function () {
            return _this._pdfViewer.currentScale;
        };
        this.getTotalPages = function () {
            return _this._pdfViewer.pagesCount;
        };
        this.findText = function (textToFind) {
            _this._pdfFindController._scrollMatches = true;
            _this._eventBus.dispatch("find", {
                query: textToFind,
                caseSensitive: false,
                entireWord: false,
                highlightAll: true,
                findPrevious: false,
                phraseSearch: true,
            });
            return new Promise(function (resolve) {
                setTimeout(function () {
                    var pages = [];
                    _this._pdfFindController._pageMatches.forEach(function (item, index) {
                        if (item.length > 0) {
                            pages.push(PageMatchesCount.create(index + 1, item.length));
                        }
                    });
                    _this._allMatches = _this._pdfFindController.pageMatches
                        .flatMap(function (matches, pageIndex) {
                        return matches.map(function (_, matchIndex) { return ({ pageIndex: pageIndex, matchIndex: matchIndex }); });
                    });
                    var totalMatches = _this._pdfFindController._matchesCountTotal;
                    var searchResult = SearchResult.create(totalMatches, pages);
                    resolve(searchResult);
                }, 1000);
            });
        };
        this.assignMatchDataAttributesForPage = function (pageContainer) {
            var allHighlights = Array.from(pageContainer.querySelectorAll('.highlight'));
            // Sort highlights by their vertical position in the page
            allHighlights.sort(function (a, b) {
                var aRect = a.getBoundingClientRect();
                var bRect = b.getBoundingClientRect();
                // First by top, then by left (for multiple columns)
                if (aRect.top === bRect.top) {
                    return aRect.left - bRect.left;
                }
                return aRect.top - bRect.top;
            });
            var matchIndex = 0;
            var currentGroup = [];
            for (var _i = 0, allHighlights_1 = allHighlights; _i < allHighlights_1.length; _i++) {
                var span = allHighlights_1[_i];
                var classList = span.classList;
                if (classList.contains('begin')) {
                    if (currentGroup.length > 0) {
                        currentGroup.forEach(function (el) { return el.setAttribute('data-match-index', String(matchIndex)); });
                    }
                    currentGroup = [span];
                }
                else if (classList.contains('middle')) {
                    if (currentGroup.length === 0) {
                        currentGroup = [span];
                    }
                    else {
                        currentGroup.push(span);
                    }
                }
                else if (classList.contains('end')) {
                    if (currentGroup.length === 0) {
                        currentGroup = [span];
                    }
                    else {
                        currentGroup.push(span);
                    }
                    currentGroup.forEach(function (el) { return el.setAttribute('data-match-index', String(matchIndex)); });
                    matchIndex++;
                    currentGroup = [];
                }
                else {
                    if (currentGroup.length > 0) {
                        currentGroup.forEach(function (el) { return el.setAttribute('data-match-index', String(matchIndex)); });
                        matchIndex++;
                        currentGroup = [];
                    }
                    span.setAttribute('data-match-index', String(matchIndex));
                    matchIndex++;
                }
            }
            if (currentGroup.length > 0) {
                currentGroup.forEach(function (el) { return el.setAttribute('data-match-index', String(matchIndex)); });
            }
        };
        this.isDocumentReady = function () {
            var _a, _b;
            return !!(((_a = _this._pdfViewer) === null || _a === void 0 ? void 0 : _a.pdfDocument) &&
                ((_b = _this._pdfFindController) === null || _b === void 0 ? void 0 : _b._pdfDocument));
        };
        this.goToNextMatch = function (index) {
            if (!_this._allMatches || _this._allMatches.length === 0)
                return;
            if (typeof index === "number") {
                _this._currentMatchIndex = index;
            }
            _this._currentMatchIndex = (_this._currentMatchIndex + 1) % _this._allMatches.length;
            _this.scrollToHighlight(_this._currentMatchIndex);
        };
        this.goToPreviousMatch = function () {
            if (!_this._allMatches || _this._allMatches.length === 0)
                return;
            _this._currentMatchIndex =
                (_this._currentMatchIndex - 1 + _this._allMatches.length) % _this._allMatches.length;
            _this.scrollToHighlight(_this._currentMatchIndex, true);
        };
        this.scrollToHighlight = function (index_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([index_1], args_1, true), void 0, function (index, isPrevious) {
                var match, pageIndex, matchIndex, pageNumber, scrollAndHighlight;
                var _this = this;
                if (isPrevious === void 0) { isPrevious = false; }
                return __generator(this, function (_a) {
                    match = this._allMatches[index];
                    pageIndex = match.pageIndex, matchIndex = match.matchIndex;
                    pageNumber = pageIndex + 1;
                    scrollAndHighlight = function () { return __awaiter(_this, void 0, void 0, function () {
                        var pageView, pageContainer, highlight, container, pageRect, highlightRect, offsetTop, isNearBottom;
                        return __generator(this, function (_a) {
                            pageView = this._pdfViewer.getPageView(pageIndex);
                            if (!pageView)
                                return [2 /*return*/];
                            pageContainer = pageView.div;
                            this.assignMatchDataAttributesForPage(pageContainer);
                            highlight = pageContainer.querySelector(".highlight[data-match-index=\"".concat(matchIndex, "\"]"));
                            if (!highlight)
                                return [2 /*return*/];
                            container = document.querySelector('.page-viewer');
                            pageRect = pageContainer.getBoundingClientRect();
                            highlightRect = highlight.getBoundingClientRect();
                            offsetTop = pageContainer.offsetTop;
                            if (isPrevious) {
                                // Scroll so that the bottom of the highlight is at the bottom of the view
                                offsetTop += highlightRect.bottom - pageRect.top - container.clientHeight;
                            }
                            else {
                                isNearBottom = highlightRect.bottom > pageRect.bottom - container.clientHeight;
                                if (isNearBottom) {
                                    offsetTop += (highlightRect.top - pageRect.top) - (container.clientHeight / 2) + (highlightRect.height / 2);
                                }
                                else {
                                    offsetTop += highlightRect.top - pageRect.top;
                                }
                            }
                            container.scrollTo({ top: offsetTop, behavior: 'smooth' });
                            return [2 /*return*/];
                        });
                    }); };
                    if (this._pdfViewer.currentPageNumber === pageNumber) {
                        setTimeout(scrollAndHighlight, 100);
                    }
                    else {
                        this._pdfViewer.scrollPageIntoView({ pageNumber: pageNumber });
                        setTimeout(scrollAndHighlight, 500);
                    }
                    return [2 /*return*/];
                });
            });
        };
        this.getCurrentSearchIndex = function () {
            return _this._currentMatchIndex;
        };
        this.resetSearchIndex = function () {
            _this._currentMatchIndex = -1;
        };
        this.resetSearchResult = function () {
            _this._allMatches = [];
            var highlightElements = document.querySelectorAll('.highlight');
            if (highlightElements) {
                highlightElements.forEach(function (highlight) {
                    highlight.classList.remove('highlight');
                    highlight.removeAttribute('data-match-index');
                });
            }
        };
        this._pdfLinkService = pdf_viewer_mjs.PDFLinkService && new pdf_viewer_mjs.PDFLinkService();
    }
    ViewerBase.create = function () {
        return new ViewerBase();
    };
    ViewerBase.prototype.initializePdfFindController = function () {
        this._pdfFindController = new pdf_viewer_mjs.PDFFindController({
            eventBus: this._eventBus,
            linkService: this._pdfLinkService
        });
    };
    ViewerBase.prototype.initializeViewer = function (container, pageMode, disableTextLayer) {
        if (pageMode == PageMode.SinglePage) {
            this._pdfViewer = new pdf_viewer_mjs.PDFSinglePageViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                findController: this._pdfFindController,
                textLayerMode: disableTextLayer ? 0 : 1,
                annotationEditorMode: pdfjs__namespace.AnnotationEditorType.DISABLE
            });
        }
        else {
            this._pdfViewer = new pdf_viewer_mjs.PDFViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                findController: this._pdfFindController,
                textLayerMode: disableTextLayer ? 0 : 1,
                annotationMode: pdfjs__namespace.AnnotationMode.ENABLE,
                annotationEditorMode: pdfjs__namespace.AnnotationEditorType.DISABLE
            });
        }
        this._pdfLinkService.setViewer(this._pdfViewer);
    };
    ViewerBase.prototype.setDocument = function (document) {
        this._pdfViewer.setDocument(document);
        this._pdfLinkService.setDocument(document, null);
        this._pdfFindController.setDocument(document);
    };
    ViewerBase.prototype.setPdfPage = function (container, document, page, scale, disableTextLayer) {
        var _self = this;
        var promise = new Promise(function (resolve) {
            document.getPage(page).then(function (pdfPage) {
                container.innerHTML = "";
                _self._pdfViewer = new pdf_viewer_mjs.PDFPageView({
                    eventBus: _self._eventBus,
                    container: container,
                    id: page,
                    scale: scale,
                    defaultViewport: pdfPage.getViewport(page),
                    textLayerMode: disableTextLayer ? 0 : 1,
                });
                _self._pdfViewer.setPdfPage(pdfPage);
                _self._pdfViewer.draw();
                resolve(page);
            }).
                catch(function (error) {
                console.error("Error: " + error);
            });
        });
        return promise;
    };
    return ViewerBase;
}());

var Viewer = /** @class */ (function (_super) {
    __extends(Viewer, _super);
    function Viewer(props) {
        var _this = _super.call(this, props) || this;
        _this._viewerBase = ViewerBase.create();
        _this.onAllPagesRendered = function () {
            setTimeout(function () {
                var _a, _b;
                if (_this._viewerBase.isDocumentReady()) {
                    (_b = (_a = _this.props).performDocumentSearch) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
            }, 500);
        };
        _this.setDocument = function (doc) {
            _this._viewerBase.setDocument(doc);
        };
        _this.getCurrentPage = function () {
            return _this._viewerBase.getCurrentPage();
        };
        _this.getPageSize = function (page) {
            return _this._viewerBase.getPageSize(page);
        };
        _this.gotoPage = function (page) {
            _this._viewerBase.gotoPage(page);
        };
        _this.setScale = function (scale) {
            _this._viewerBase.setScale(scale);
        };
        _this.getCurrentScale = function () {
            return _this._viewerBase.getCurrentScale();
        };
        _this.getTotalPages = function () {
            return _this._viewerBase.getTotalPages();
        };
        _this.searchText = function (textToFind) {
            return _this._viewerBase.findText(textToFind);
        };
        _this.goToPreviousMatch = function () {
            return _this._viewerBase.goToPreviousMatch();
        };
        _this.goToNextMatch = function (index) {
            return _this._viewerBase.goToNextMatch(index);
        };
        _this.setLoaderStatus = function (status) {
            _this.setState({ showLoader: status });
        };
        _this.setViewerMode = function (viewerMode) {
            _this.setState({ viewerMode: viewerMode });
        };
        _this.getCurrentSearchIndex = function () {
            return _this._viewerBase.getCurrentSearchIndex();
        };
        _this.resetSearchIndex = function () {
            _this._viewerBase.resetSearchIndex();
        };
        _this.resetSearchResult = function () {
            _this._viewerBase.resetSearchResult();
        };
        _this.initEventBus();
        // Create the ref for the container
        _this.containerRef = React__namespace.createRef();
        _this.state = {
            showLoader: true,
            viewerMode: ViewerMode.Normal
        };
        return _this;
    }
    Viewer.prototype.initEventBus = function () {
        var _this = this;
        var eventBus = this._viewerBase.getEventBus();
        eventBus.on('pagesinit', function () {
            var _a, _b;
            var pageProperties = PageProperties.create(_this._viewerBase.getCurrentPage(), _this._viewerBase.getCurrentScale());
            (_b = (_a = _this.props).onDocumentLoad) === null || _b === void 0 ? void 0 : _b.call(_a, pageProperties);
            if (_this.props.trackPageRendering && _this.props.getPageRenderingStatusCallBack) {
                _this.props.getPageRenderingStatusCallBack();
            }
        });
        eventBus.on('pagerendered', function (evt) {
            var _a, _b;
            if (_this.state.showLoader) {
                _this.setState({ showLoader: false }, function () {
                    if (_this.props.trackPageRendering && _this.props.getPageRenderingStatusCallBack) {
                        _this.props.getPageRenderingStatusCallBack();
                    }
                });
            }
            (_b = (_a = _this.props).onPageChanged) === null || _b === void 0 ? void 0 : _b.call(_a, PageProperties.create(evt.pageNumber, _this._viewerBase.getCurrentScale()));
        });
        eventBus.on('scalechanging', function (e) {
            var _a, _b;
            (_b = (_a = _this.props).onScaleChanged) === null || _b === void 0 ? void 0 : _b.call(_a, PageProperties.create(_this._viewerBase.getCurrentPage(), e.scale));
        });
        eventBus.on('pagechanging', function (e) {
            var _a, _b;
            var pageProperties = PageProperties.create(e.pageNumber, _this._viewerBase.getCurrentScale());
            (_b = (_a = _this.props).onPageChanging) === null || _b === void 0 ? void 0 : _b.call(_a, pageProperties);
        });
        eventBus.on('pagesloaded', function () {
            _this.onAllPagesRendered();
        });
    };
    Viewer.prototype.componentDidMount = function () {
        var _a = this.props, pageMode = _a.pageMode, disableTextLayer = _a.disableTextLayer;
        this._viewerBase.initializePdfFindController();
        this._viewerBase.initializeViewer(this.containerRef.current, pageMode, disableTextLayer);
    };
    Viewer.prototype.render = function () {
        var viewerReadModeClass = this.state.viewerMode == ViewerMode.Read ? " read-mode-enabled " : "";
        return (React__namespace.createElement("div", { className: 'pdf-viewer-container' },
            React__namespace.createElement("div", { className: "page-viewer " + viewerReadModeClass, id: "page-viewer", ref: this.containerRef },
                React__namespace.createElement("div", { className: "pdfViewer", id: "pdfViewer" }),
                this.props.children,
                React__namespace.createElement(Loader, { show: this.state.showLoader }))));
    };
    return Viewer;
}(React__namespace.Component));

var ClassicPageViewer = /** @class */ (function (_super) {
    __extends(ClassicPageViewer, _super);
    function ClassicPageViewer(props) {
        var _this = _super.call(this, props) || this;
        _this._totalPages = 0;
        _this._pageNum = 1;
        _this._scale = 1;
        _this._viewerBase = ViewerBase.create();
        _this.setDocument = function (doc) {
            var _self = _this;
            var onDocumentLoad = _self.props.onDocumentLoad;
            _self._documentData = doc;
            _self._totalPages = _this._documentData.numPages;
            _self._pageNum = 1;
            _self.renderPage(_self._pageNum, _self._scale).then(function (pdfPage) {
                var pageProperties = PageProperties.create(_self._pageNum, _self._scale);
                onDocumentLoad && onDocumentLoad(pageProperties);
            });
        };
        _this.getCurrentPage = function () {
            return _this._pageNum;
        };
        _this.getPageSize = function (page) {
            var currentPage = _this._viewerBase._pdfViewer;
            if (currentPage != null) {
                return PageSize.create(currentPage.viewport.height / currentPage.viewport.scale, currentPage.viewport.width / currentPage.viewport.scale);
            }
            else {
                return PageSize.createNullObject();
            }
        };
        _this.gotoPage = function (page) {
            var _self = _this;
            _self._pageNum = page;
            var onPageChanging = _self.props.onPageChanging;
            _this.renderPage(_this._pageNum, _this._scale).then(function (pdfPage) {
                onPageChanging && onPageChanging(PageProperties.create(_self._pageNum, _self._scale));
            });
        };
        _this.setScale = function (scale) {
            var _self = _this;
            var onScaleChanged = _self.props.onScaleChanged;
            _self._scale = scale;
            _self.renderPage(_self._pageNum, _self._scale).then(function (pdfPage) {
                onScaleChanged && onScaleChanged(PageProperties.create(_self._pageNum, _self._scale));
            });
        };
        _this.getCurrentScale = function () {
            return _this._scale;
        };
        _this.getTotalPages = function () {
            return _this._totalPages;
        };
        _this.searchText = function (textToFind) {
            return _this._viewerBase.findText(textToFind);
        };
        _this.goToPreviousMatch = function () {
            _this._viewerBase.goToPreviousMatch();
        };
        _this.goToNextMatch = function (index) {
            _this._viewerBase.goToNextMatch(index);
        };
        _this.setLoaderStatus = function (status) {
            _this.setState({ showLoader: status });
        };
        _this.setViewerMode = function (viewerMode) {
        };
        _this.getCurrentSearchIndex = function () {
            return _this._viewerBase.getCurrentSearchIndex();
        };
        _this.resetSearchIndex = function () {
            _this._viewerBase.resetSearchIndex();
        };
        _this.resetSearchResult = function () {
            _this._viewerBase.resetSearchResult();
        };
        _this.renderPage = function (page, scale) {
            var disableTextLayer = _this.props.disableTextLayer;
            var viewerContainer = document.getElementById('pdfViewer');
            return _this._viewerBase.setPdfPage(viewerContainer, _this._documentData, page, scale, disableTextLayer);
        };
        _this.initEventBus();
        _this.state = {
            showLoader: true,
            viewerMode: ViewerMode.Normal
        };
        return _this;
    }
    ClassicPageViewer.prototype.initEventBus = function () {
        var _this = this;
        var eventBus = this._viewerBase.getEventBus();
        eventBus.on('pagerendered', function () {
            _this.state.showLoader && _this.setState({ showLoader: false });
            if (_this.props.onPageChanged) {
                _this.props.onPageChanged(PageProperties.create(_this._pageNum, _this._scale));
            }
        });
    };
    ClassicPageViewer.prototype.componentDidMount = function () {
    };
    ClassicPageViewer.prototype.render = function () {
        var viewerReadModeClass = this.state.viewerMode == ViewerMode.Read ? " read-mode-enabled " : "";
        return (React__namespace.createElement("div", { className: 'pdf-viewer-container' },
            React__namespace.createElement("div", { className: "page-viewer " + viewerReadModeClass, id: "page-viewer" },
                React__namespace.createElement("div", { className: "pdfViewer", id: "pdfViewer" }),
                this.props.children,
                React__namespace.createElement(Loader, { show: this.state.showLoader }))));
    };
    return ClassicPageViewer;
}(React__namespace.Component));

var FileClient = /** @class */ (function () {
    function FileClient(pdfWorker) {
        this.pdfWorker = pdfWorker;
        pdfjs__namespace.GlobalWorkerOptions.workerSrc = this.pdfWorker;
    }
    FileClient.prototype.download = function (url) {
        return new Promise(function (resolve, reject) {
            var loadingTask = pdfjs__namespace.getDocument(url);
            loadingTask.promise.then(function (doc) {
                resolve(doc);
            }, function (error) {
                reject(error);
            });
        });
    };
    FileClient.prototype.getDocument = function (base64Data) {
        var pdfData = atob(base64Data);
        return new Promise(function (resolve, reject) {
            var loadingTask = pdfjs__namespace.getDocument({ data: pdfData });
            loadingTask.promise.then(function (doc) {
                resolve(doc);
            }, function (error) {
                reject(error);
            });
        });
    };
    FileClient.create = function (pdfWorker) {
        return new FileClient(pdfWorker);
    };
    return FileClient;
}());
var IEFileClient = /** @class */ (function () {
    function IEFileClient(pdfWorker) {
        this.pdfWorker = pdfWorker;
        pdfjs__namespace.GlobalWorkerOptions.workerSrc = this.pdfWorker;
    }
    IEFileClient.prototype.download = function (url) {
        return new Promise(function (resolve, reject) {
            fetch(url).then(function (response) {
                if (response.ok) {
                    return response.blob();
                }
                throw new Error('Error in network response/slow network !!');
            }).then(function (responseData) {
                var objectURL = URL.createObjectURL(responseData);
                var loadingTask = pdfjs__namespace.getDocument(objectURL);
                loadingTask.promise.then(function (doc) {
                    resolve(doc);
                }, function (error) {
                    reject(error);
                });
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    IEFileClient.prototype.getDocument = function (base64Data) {
        var pdfData = atob(base64Data);
        return new Promise(function (resolve, reject) {
            var loadingTask = pdfjs__namespace.getDocument({ data: pdfData });
            loadingTask.promise.then(function (doc) {
                resolve(doc);
            }, function (error) {
                reject(error);
            });
        });
    };
    IEFileClient.create = function (pdfWorker) {
        return new IEFileClient(pdfWorker);
    };
    return IEFileClient;
}());

var FileClientFactory = /** @class */ (function () {
    function FileClientFactory() {
    }
    FileClientFactory.getFileClient = function (pdfWorker) {
        try {
            if (/msie\s|trident\/|edge\//i.test(window.navigator.userAgent)) {
                return new IEFileClient(pdfWorker);
            }
            else {
                return new FileClient(pdfWorker);
            }
        }
        catch (error) {
            return new FileClient(pdfWorker);
        }
    };
    return FileClientFactory;
}());

var ViewPanel = /** @class */ (function (_super) {
    __extends(ViewPanel, _super);
    function ViewPanel(props) {
        var _this = _super.call(this, props) || this;
        _this._pdfJsFileClient = FileClientFactory.getFileClient(_this.props.pdfWorkerSource);
        _this.loadPDF = function (source) {
            if (source.url) {
                _this.loadFromUrl(source.url);
            }
            else if (source.base64String) {
                _this.loadPdfFromBase64(source.base64String);
            }
            else if (source.pdfDocumentProxy) {
                _this.loadFromPDFDocumentProxy(source.pdfDocumentProxy);
            }
            else {
                _this.loadFromUrl("");
            }
        };
        _this.loadFromUrl = function (url) {
            var _self = _this;
            url && _this._pdfJsFileClient.download(url)
                .then(function (doc) {
                _self.documentReady(doc);
                if (_self._viewer) {
                    _self._viewer.setDocument(doc);
                    _self._viewer.setScale(_this.getInitialScaleBaseOnScreenWidth());
                    _self.resetSearchIndex();
                    _self.resetSearchResult();
                }
            }, function (error) {
                console.error(error);
            });
        };
        _this.loadPdfFromBase64 = function (base64Data) {
            var _self = _this;
            _this._pdfJsFileClient.getDocument(base64Data)
                .then(function (doc) {
                _self.documentReady(doc);
                if (_self._viewer) {
                    _self._viewer.setDocument(doc);
                    _self._viewer.setScale(_this.getInitialScaleBaseOnScreenWidth());
                    _self.resetSearchIndex();
                    _self.resetSearchResult();
                }
            }, function (error) {
                console.error(error);
            });
        };
        _this.loadFromPDFDocumentProxy = function (pdfDocumentProxy) {
            _this.documentReady(pdfDocumentProxy);
            if (_this._viewer) {
                _this._viewer.setDocument(pdfDocumentProxy);
                _this._viewer.setScale(_this.getInitialScaleBaseOnScreenWidth());
                _this.resetSearchIndex();
                _this.resetSearchResult();
            }
        };
        _this.zoomIn = function () {
            if (_this._viewer) {
                _this._viewer.setScale(_this._viewer.getCurrentScale() * 1.1);
                _this.props.onScaleChanged && _this.props.onScaleChanged(_this._viewer.getCurrentScale());
            }
        };
        _this.zoomOut = function () {
            if (_this._viewer) {
                _this._viewer.setScale(_this._viewer.getCurrentScale() / 1.1);
                _this.props.onScaleChanged && _this.props.onScaleChanged(_this._viewer.getCurrentScale());
            }
        };
        _this.zoomChange = function (scale) {
            if (_this._viewer) {
                _this._viewer.setScale(scale);
                _this.props.onScaleChanged && _this.props.onScaleChanged(_this._viewer.getCurrentScale());
            }
        };
        _this.nextPage = function () {
            _this._viewer && _this._viewer.gotoPage(_this._viewer.getCurrentPage() + 1);
        };
        _this.previousPage = function () {
            _this._viewer && _this._viewer.gotoPage(_this._viewer.getCurrentPage() - 1);
        };
        _this.gotoPage = function (page) {
            _this._viewer && _this._viewer.gotoPage(page);
        };
        _this.getTotalPages = function () {
            return _this._viewer ? _this._viewer.getTotalPages() : 0;
        };
        _this.getCurrentPageNumber = function () {
            return _this._viewer ? _this._viewer.getCurrentPage() : 0;
        };
        _this.getPageSize = function (page) {
            return _this._viewer ? _this._viewer.getPageSize(page) : PageSize.createNullObject();
        };
        _this.searchText = function (textToFind) {
            var _self = _this;
            return _this._viewer && _this._viewer.searchText(textToFind).then(function (searchResult) {
                if (_self.props.isNavigateToFirstSearchMatch) {
                    _self.handleNext(-1);
                }
                return searchResult;
            });
        };
        _this.handlePrev = function () {
            _this._viewer && _this._viewer.goToPreviousMatch();
            if (_this.props.trackSearchIndex && _this._viewer) {
                _this.props.getCurrentSearchIndexCallBack && _this.props.getCurrentSearchIndexCallBack(_this._viewer.getCurrentSearchIndex());
            }
        };
        _this.handleNext = function (index) {
            _this._viewer && _this._viewer.goToNextMatch(index);
            if (_this.props.trackSearchIndex && _this._viewer) {
                _this.props.getCurrentSearchIndexCallBack && _this.props.getCurrentSearchIndexCallBack(_this._viewer.getCurrentSearchIndex());
            }
        };
        _this.resetSearchIndex = function () {
            if (_this._viewer) {
                _this._viewer.resetSearchIndex();
                _this.props.getCurrentSearchIndexCallBack && _this.props.getCurrentSearchIndexCallBack(_this._viewer.getCurrentSearchIndex());
            }
        };
        _this.resetSearchResult = function () {
            if (_this._viewer) {
                _this._viewer.resetSearchResult();
            }
            if (_this.props.getSearchResultCallBack) {
                _this.props.getSearchResultCallBack(SearchResult.createNullObject());
            }
        };
        _this.getDocument = function () {
            return _this._document;
        };
        _this.setViewerMode = function (viewerMode) {
            _this._viewer && _this._viewer.setViewerMode(viewerMode);
        };
        _this.resetCurrentStepFocus = function () {
            _this._controlLayer && _this._controlLayer.resetCurrentStepFocus();
        };
        _this.performDocumentSearch = function () {
            var _a, _b;
            if (_this.props.getSearchResultCallBack) {
                _this.getPageRenderingStatus();
                var _self_1 = _this;
                _this.searchText((_a = _this.props.searchText) !== null && _a !== void 0 ? _a : "").then(function (searchResult) {
                    _self_1.setState({ searchResult: searchResult }, function () {
                        _self_1.props.getSearchResultCallBack && _self_1.props.getSearchResultCallBack(searchResult);
                        if (_self_1.props.isNavigateToFirstSearchMatch) {
                            _self_1.handleNext(-1);
                        }
                    });
                });
            }
            else {
                _this.searchText((_b = _this.props.searchText) !== null && _b !== void 0 ? _b : "");
            }
        };
        _this.getPageRenderingStatus = function () {
            _this.props.getPageRenderingStatusCallBack && _this._viewer &&
                _this.props.getPageRenderingStatusCallBack(_this._viewer.state.showLoader);
        };
        //#region setReference Methods
        _this.setToolbarReference = function (toolbar) {
            _this._toolbar = toolbar;
        };
        _this.setControlsReference = function (controls) {
            _this._controls = controls;
        };
        _this.setControlLayerReference = function (controlLayer) {
            _this._controlLayer = controlLayer;
        };
        _this.setBookmarkPanelReference = function (bookmarkPanel) {
            _this._bookmarkPanel = bookmarkPanel;
        };
        //#endregion
        //#region Validate Reference region
        _this.validateToolbarReference = function () {
            return _this._toolbar ? true : false;
        };
        _this.validateControlsReference = function () {
            return _this._controls ? true : false;
        };
        _this.validateControlLayerReference = function () {
            return _this._controlLayer ? true : false;
        };
        _this.validateBookmarkPanelReference = function () {
            return !_this._bookmarkPanel;
        };
        //#endregion
        //#region  Reference Events
        _this.updateControlState = function (pageProperties) {
            var _self = _this;
            pageProperties = pageProperties;
            _self._controls && _self._controls.forEach(function (item) {
                item && item.updateControlState(pageProperties);
            });
            _this.resetCurrentStepFocus();
        };
        _this.updateControlLayerState = function (pageProperties) {
            if (_this.validateControlLayerReference()) {
                _this._controlLayer.updateState(pageProperties);
            }
        };
        _this.setBookmarkPanelDocument = function (document) {
            if (_this._bookmarkPanel) {
                _this._bookmarkPanel.setDocument(document);
            }
        };
        //#endregion
        //#region Viewer Events
        _this.documentReady = function (document) {
            _this._document = document;
            _this.setBookmarkPanelDocument(document);
        };
        _this.handleDocumentLoad = function (pageProperties) {
            if (_this.validateToolbarReference()) {
                _this._toolbar.updateState(pageProperties);
            }
            if (_this.validateControlLayerReference()) {
                _this._controlLayer.removeAllNavigationSteps();
            }
            if (_this.props.onDocumentLoad) {
                _this.props.onDocumentLoad && _this.props.onDocumentLoad(pageProperties);
            }
            _this._controlLayer && _this._controlLayer.closeNavigation();
            if (_this.props.defaultPage)
                _this._viewer && _this._viewer.gotoPage(_this.props.defaultPage);
        };
        _this.handlePageChanging = function (pageProperties) {
            if (_this.validateToolbarReference()) {
                _this._toolbar.updateState(pageProperties);
            }
            if (_this.props.onPageChanged) {
                _this.props.onPageChanged(pageProperties);
            }
            _this.resetCurrentStepFocus();
        };
        _this.handlePageChanged = function (pageProperties) {
            _this.updateControlState(pageProperties);
            _this._controlLayer && _this._controlLayer.updateState(pageProperties);
        };
        _this.state = {};
        return _this;
    }
    ViewPanel.prototype.componentDidMount = function () {
        this.loadPDF(this.props.pdfSource);
    };
    ViewPanel.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        nextProps = nextProps;
        if ((nextProps.url && this.props.url !== nextProps.url) ||
            (nextProps.pdfData && this.props.pdfData !== nextProps.pdfData) ||
            (nextProps.pdfSource && !nextProps.pdfSource.url && this.props.pdfSource !== nextProps.pdfSource) ||
            (nextProps.pdfSource && nextProps.pdfSource.url && this.props.pdfSource.url !== nextProps.pdfSource.url)) {
            if (this._viewer) {
                this._viewer.setLoaderStatus(true);
                this.loadPDF(nextProps.pdfSource);
            }
            return false;
        }
        return false;
    };
    ViewPanel.prototype.getInitialScaleBaseOnScreenWidth = function () {
        if (this.props.customWidth) {
            return (this.props.customWidth / 1200) + .10;
        }
        return screen.width >= 1200 ? 1 : (screen.width / 1200) + .10; // scree size >= 1200 is laptop so scale will be set to 1
    };
    ViewPanel.prototype.displayScaleChanged = function (e) {
    };
    //#endregion
    ViewPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, pageMode = _a.pageMode, disableTextLayer = _a.disableTextLayer, children = _a.children;
        if (pageMode == PageMode.Classic) {
            return (React__namespace.createElement(ClassicPageViewer, { ref: function (ref) { return _this._viewer = ref; }, onDocumentLoad: this.handleDocumentLoad, onPageChanging: this.handlePageChanging, pageMode: pageMode, onPageChanged: this.handlePageChanged, disableTextLayer: disableTextLayer }, children));
        }
        else {
            return (React__namespace.createElement(Viewer, { ref: function (ref) { return _this._viewer = ref; }, onDocumentLoad: this.handleDocumentLoad, onPageChanging: this.handlePageChanging, pageMode: pageMode, onPageChanged: this.handlePageChanged, disableTextLayer: disableTextLayer, performDocumentSearch: this.performDocumentSearch, trackPageRendering: this.props.trackPageRendering, getPageRenderingStatusCallBack: this.getPageRenderingStatus }, children));
        }
    };
    return ViewPanel;
}(React__namespace.Component));

exports.ViewPanel = ViewPanel;
exports.default = ViewPanel;
